import {
  CommunicationUnitPackage,
  CommunicationUnitPrice,
  CreditOrder,
  Invoice,
  InvoiceDetail,
} from '../models';
import { DateTimeUtils } from '../utils';

export class SmsUtils {
  // region Credit package
  public static transformCreditPackagesForFrontend(
    creditPackages: CommunicationUnitPackage[]
  ): CommunicationUnitPackage[] {
    if (!creditPackages?.length) {
      return [];
    }

    return creditPackages.sort(
      (a: CommunicationUnitPackage, b: CommunicationUnitPackage): number => {
        if (a.countryCode < b.countryCode) {
          return -1;
        }

        if (a.countryCode > b.countryCode) {
          return 1;
        }

        if (a.provider < b.provider) {
          return -1;
        }

        if (a.provider > b.provider) {
          return 1;
        }

        if (a.balance < b.balance) {
          return -1;
        }

        if (a.balance > b.balance) {
          return 1;
        }

        return 0;
      }
    );
  }

  public static transformCommunicationUnitPricesForFrontend(
    unitPrices: CommunicationUnitPrice[]
  ): CommunicationUnitPrice[] {
    if (!unitPrices?.length) {
      return [];
    }

    return unitPrices.sort(
      (a: CommunicationUnitPrice, b: CommunicationUnitPrice): number => {
        if (a.communicationWay < b.communicationWay) {
          return -1;
        }

        if (a.communicationWay > b.communicationWay) {
          return 1;
        }

        if (a.countryCode < b.countryCode) {
          return -1;
        }

        if (a.countryCode > b.countryCode) {
          return 1;
        }

        if (a.provider < b.provider) {
          return -1;
        }

        if (a.provider > b.provider) {
          return 1;
        }

        return 0;
      }
    );
  }

  public static transformCreditOrderForFrontend(
    creditOrder: CreditOrder
  ): CreditOrder {
    if (!creditOrder) {
      return null;
    }

    return {
      ...creditOrder,
      createdAtAsDate: DateTimeUtils.parseStringToDate(
        `${creditOrder.createdAt}Z`
      ),
    };
  }

  // endregion

  // region Invoice

  public static transformInvoiceListForFrontend(
    invoiceList: Invoice[]
  ): Invoice[] {
    if (!invoiceList?.length) {
      return invoiceList;
    }

    invoiceList.sort((i1, i2) => i2.dueDate?.localeCompare(i1.dueDate));
    return invoiceList
      .filter(
        (i) => i.voucherStatus !== 'draft' && i.voucherStatus !== 'voided'
      )
      ?.map((i) => this.transformInvoiceForFrontend(i));
  }

  public static transformInvoiceForFrontend(invoice: Invoice): Invoice {
    if (!invoice) {
      return invoice;
    }

    return {
      ...invoice,
      dueDateAsDate: DateTimeUtils.parseStringToDate(invoice.dueDate),
      voucherDateAsDate: DateTimeUtils.parseStringToDate(invoice.voucherDate),
    };
  }

  public static transformInvoiceDetailForFrontend(
    invoice: InvoiceDetail
  ): InvoiceDetail {
    if (!invoice) {
      return invoice;
    }

    return {
      ...invoice,
      createdDateAsDate: DateTimeUtils.parseStringToDate(invoice.createdDate),
      dueDateAsDate: DateTimeUtils.parseStringToDate(invoice.dueDate),
    };
  }

  // endregion
}
